/**
 * @ngdoc service
 * @name mx.shell.SidebarService
 * @module mx.shell
 *
 * @property {boolean} isOpened - get or set state of `Right Side Bar` whether it is opened
 * @property {boolean} isPinnedOpen - get or set state of `Right Side Bar` whether it is pinned as open.
 * @property {mx.shell.View} view - `View` which should be shown inside of `Right Side Bar`
 * @property {array} additionalButtons - an array of objects which represent Buttons for `Right Side Bar` in right stripe.
 *			Objects may contain keys like: unique `name`, `icon`, `title`, and `active`.
 *			Example: [
 *				{name: 'feedback', icon: 'feedback', title: 'Open feedback', active: true},
 *				{name: 'save', icon: 'save', title: 'Save all'},
 *				...
 *			]
 *			Ones some button is clicked an event `mx.shell.SidenavAdditionalButtonClick` will be fired.
 *			(In future those buttons could be reworked with `mx.shell.Action`)
 *
 * @description
 * A service provides methods for managing the right Sidebar panel appearance.
 */
export class SidebarService {
	static $inject = ['mx.shell.EventService'];

	constructor(eventService) {
		this.eventService = eventService;

		this.isOpened = false;
		this.isPinnedOpen = false;
		this.view = undefined;
		this.additionalButtons = [];

		this._debouncedLayoutChangeDispatcher = $.debounce(500, function () {
			eventService.dispatchEvent(mx.shell.EventCodes.LayoutChanged);
		});
	}

	/**
	 * @ngdoc method
	 * @name mx.shell.SidebarService#open
	 *
	 * @description
	 * Opens right sidebar with the markup and scope passed.
	 *
	 * @param {mx.shell.View} `view` that shoulh be shown.
	 * @param {array} `buttonList` - an array of buttons.
	 */
	open(view, buttonList) {
		this.view = view;
		this.additionalButtons = buttonList;
		this.show();
	}

	/**
	 * @ngdoc method
	 * @name mx.shell.SidebarService#show
	 *
	 * @description
	 * Opens right sidebar.
	 */
	show() {
		this.isOpened = true;
		this._debouncedLayoutChangeDispatcher();
	}

	/**
	 * @ngdoc method
	 * @name mx.shell.SidebarService#togglePinnedOpen
	 *
	 * @description
	 * Toggle pinned open state.
	 */
	togglePinnedOpen() {
		this.isPinnedOpen = !this.isPinnedOpen;
	}

	/**
	 * @ngdoc method
	 * @name mx.shell.SidebarService#close
	 *
	 * @description
	 * Closes right sidebar if it isn't pinned.
	 */
	close() {
		if (!this.isPinnedOpen) {
			this.isOpened = false;
			this.view = undefined;
			this.eventService.dispatchEvent(mx.shell.EventCodes.SidebarClosed);
			this._debouncedLayoutChangeDispatcher();
		}
	}
}
